import { STREAMING_SUPPLIER } from '../../data-types/stream/streamEnums';
import { PaymentData } from '../../data-types/wallet/walletInterfaces';
import { store } from '../store';
import {
  SET_DEPOSIT_TRACKING,
  SET_FEEDBACK_IFRAME_SRC,
  SET_IS_ZENDESK_OPEN,
  SET_PAYMENT_IFRAME_DIALOG_URL,
  SET_REGISTRATION_TRACKING,
  SET_STREAM_BETRADAR_STATUS,
  SET_STREAM_IFRAME_EVENT_ID,
  SET_STREAM_IFRAME_SRC,
  SET_STREAMING_SUPPLIER,
} from '../types/iframeTypes';

export const setPaymentIframeDialogSource = (meta: PaymentData | undefined) => {
  store.dispatch({
    meta,
    type: SET_PAYMENT_IFRAME_DIALOG_URL,
  });
};

export const setFeedbackIframeSource = (meta: string | undefined) => {
  store.dispatch({
    meta,
    type: SET_FEEDBACK_IFRAME_SRC,
  });
};

export const setStreamIframeSource = (meta: string | undefined) => {
  store.dispatch({
    meta,
    type: SET_STREAM_IFRAME_SRC,
  });
};

export const setStreamIframeEventId = (meta: number | undefined) => {
  store.dispatch({
    meta,
    type: SET_STREAM_IFRAME_EVENT_ID,
  });
};

export const setStreamingSupplier = (meta: STREAMING_SUPPLIER | undefined) => {
  store.dispatch({
    meta,
    type: SET_STREAMING_SUPPLIER,
  });
};

export const setStreamBetradarStatus = (meta: string | undefined) => {
  store.dispatch({
    meta,
    type: SET_STREAM_BETRADAR_STATUS,
  });
};

export const setIncomeAccessDepositTracking = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_DEPOSIT_TRACKING,
  });
};

export const setIncomeAccessRegistrationTracking = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_REGISTRATION_TRACKING,
  });
};

export const setIsZendeskOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_IS_ZENDESK_OPEN,
  });
};
